import { formatTimezoneOffsetLabel, timezoneLabel as formatTimezoneLabel } from './timezones';

export const SUPPORTED_CURRENCIES = [
  'USD',
  'CAD',
];

const ZERO_DECIMAL_CURRENCIES = new Set([]);

const COUNTRY_TO_CURRENCY = {
  US: 'USD',
  CA: 'CAD',
};

export function normalizeCurrency(value, fallback = 'USD') {
  const currency = String(value || '').trim().toUpperCase();
  if (SUPPORTED_CURRENCIES.includes(currency)) return currency;
  return fallback;
}

export function currencyMinorUnit(currency) {
  return ZERO_DECIMAL_CURRENCIES.has(normalizeCurrency(currency)) ? 0 : 2;
}

export function toMinorUnits(amount, currency) {
  const parsed = Number(amount);
  if (!Number.isFinite(parsed) || parsed <= 0) return null;
  const power = 10 ** currencyMinorUnit(currency);
  return Math.round(parsed * power);
}

export function fromMinorUnits(amountMinor, currency) {
  const parsed = Number(amountMinor);
  if (!Number.isFinite(parsed)) return NaN;
  const power = 10 ** currencyMinorUnit(currency);
  return parsed / power;
}

export function formatMoney(amount, currency = 'USD') {
  const parsed = Number(amount);
  if (!Number.isFinite(parsed)) return '—';
  return new Intl.NumberFormat(undefined, {
    style: 'currency',
    currency: normalizeCurrency(currency),
    maximumFractionDigits: currencyMinorUnit(currency),
    minimumFractionDigits: currencyMinorUnit(currency),
  }).format(parsed);
}

export function calculatePlatformFeeAmount(baseAmount, feeRate = 0.15) {
  const parsed = Number(baseAmount);
  if (!Number.isFinite(parsed) || parsed <= 0) return NaN;
  return parsed * feeRate;
}

export function calculateFanPriceFromArtistTarget(baseAmount, feeRate = 0.15) {
  const parsed = Number(baseAmount);
  if (!Number.isFinite(parsed) || parsed <= 0) return NaN;
  return parsed + calculatePlatformFeeAmount(parsed, feeRate);
}

export function guessCurrencyFromCountry(countryCode, fallback = 'USD') {
  const code = String(countryCode || '').trim().toUpperCase();
  return normalizeCurrency(COUNTRY_TO_CURRENCY[code], fallback);
}

export function timezoneLabel(timezone) {
  return formatTimezoneLabel(timezone);
}

export function timezoneOffsetLabel(timezone, date = new Date()) {
  return formatTimezoneOffsetLabel(timezone, date);
}
